"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyboardShortcutKeys = exports.getKeyboardShortcutKey = exports.onShortcut = exports.useShortcuts = exports.ShortcutsProvider = void 0;
var Shortcuts_1 = require("./Shortcuts");
Object.defineProperty(exports, "ShortcutsProvider", { enumerable: true, get: function () { return Shortcuts_1.ShortcutsProvider; } });
Object.defineProperty(exports, "useShortcuts", { enumerable: true, get: function () { return Shortcuts_1.useShortcuts; } });
var keyboard_1 = require("./keyboard");
Object.defineProperty(exports, "getKeyboardShortcutKey", { enumerable: true, get: function () { return keyboard_1.getKeyboardShortcutKey; } });
Object.defineProperty(exports, "getKeyboardShortcutKeys", { enumerable: true, get: function () { return keyboard_1.getKeyboardShortcutKeys; } });
var onShortcut_1 = __importDefault(require("./onShortcut"));
exports.onShortcut = onShortcut_1.default;
